import {Modal} from 'react-bootstrap'
import styles from './InformationModal.css'

class InformationModal extends React.Component {
  render () {
    return (<Modal show={this.props.show} onHide={() => {}} dialogClassName={styles.dialog}>
      <Modal.Header>
        <span className={styles.title}>Information</span>
      </Modal.Header>
      <Modal.Body>
        Error: {this.props.message}
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-default' onClick={this.props.onHide}>
          OK
        </button>
      </Modal.Footer>
    </Modal>)
  }
}

InformationModal.propTypes = {
  show: React.PropTypes.bool,
  message: React.PropTypes.message,
  onHide: React.PropTypes.func
}
export default InformationModal



// WEBPACK FOOTER //
// ./app/components/ImportModal/InformationModal/InformationModal.js